import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { Redirect, Route } from 'react-router';

import ErrorBoundary from 'app/components/common/ErrorBoundary';

const SignInRequiredRoute = ({
  component: Component,
  isAuthenticated,
  ...rest
}) => {
  const render = (props) => {
    const { pathname, search } = props.location; // eslint-disable-line
    const next = `${pathname}${search}`;
    const encodedNext = encodeURIComponent(next);
    if (isAuthenticated) {
      return (
        <ErrorBoundary>
          <Component {...props} />
        </ErrorBoundary>
      );
    }

    return <Redirect to={`/signin?next=${encodedNext}`} />;
  };
  return <Route {...rest} render={render} />;
};

SignInRequiredRoute.propTypes = {
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.common.user.isLoaded,
});
const connector = connect(mapStateToProps);

export default connector(SignInRequiredRoute);



// WEBPACK FOOTER //
// ./src/app/components/routes/SignInRequiredRoute/index.jsx